module.exports = __webpack_public_path__ + "static/media/polytope_5_52_3_layers_2_2.4234d0d6.gif";